import * as React from 'react';
import * as classNames from 'classnames';
import './style.css';

export interface AuthFormProps
  extends React.FormHTMLAttributes<HTMLFormElement> {
  /* empty */
}

export interface AuthFormState {
  /* empty */
}

export class AuthForm extends React.Component<AuthFormProps, AuthFormState> {
  render() {
    return (
      <form
        {...this.props}
        className={classNames('auth-form', this.props.className)}
      >
        {this.props.children}
      </form>
    );
  }
}

export default AuthForm;



// WEBPACK FOOTER //
// ./src/app/components/Auth/AuthForm/index.tsx